/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TableCell, TableHead, TableRow } from '@mui/material';

import { Namespaces } from '../../../../../../../../i18n';
import { useTableStyles } from '../../../../../../../../styles/table';

export function DatasetImportsTableHead() {
  const tableClasses = useTableStyles();
  const { t } = useTranslation(Namespaces.Cluster);

  return (
    <TableHead>
      <TableRow>
        <TableCell className={tableClasses.headerTableCell}>&nbsp;</TableCell>
        <TableCell className={tableClasses.headerTableCell}>{t('details.datasets.table.database')}</TableCell>
        <TableCell className={cx(tableClasses.headerTableCell)}>{t('details.datasets.table.dataset')}</TableCell>
        <TableCell className={tableClasses.headerTableCell}>{t('details.datasets.table.schema')}</TableCell>
        <TableCell className={tableClasses.headerTableCell}>{t('details.datasets.table.category')}</TableCell>
        <TableCell className={tableClasses.headerTableCell}>{t('details.datasets.table.permission')}</TableCell>
        <TableCell className={tableClasses.headerTableCell}>{t('details.datasets.table.status')}</TableCell>
        <TableCell className={cx(tableClasses.headerTableCell, tableClasses.textAlignRight)}>
          {t('details.datasets.table.actions')}
        </TableCell>
      </TableRow>
    </TableHead>
  );
}
